import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';

@Component({
    selector: 'error-message',
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
    standalone: true
})
export class ErrorMessageComponent extends SaComponent implements AfterViewInit {
  @Input('message') messageInput: string;
  @ViewChild('container') container: ElementRef<HTMLDivElement>;

  readonly CONSTANTS: any = {
    defaultMessage: ''
  };

  constructor(private readonly translocoService: TranslocoService){
    super();
  }

  get message(): string {
    this.translocoService.selectTranslateObject('profileManagement.errorMessage').pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.CONSTANTS.defaultMessage = translate.textCompleteRequest;
    });
    return this.messageInput || this.CONSTANTS.defaultMessage;
  }

  ngAfterViewInit(): void {
    this.container.nativeElement.focus();
  }
}
